module.exports = __webpack_public_path__ + "static/media/bouble_1_d.0384aae9.png";